import { createContext, useContext, useState, useEffect } from "react";
import { api } from "../services/api";

const PlatformAuthContext = createContext();

export function usePlatformAuth() {
  return useContext(PlatformAuthContext);
}

// Auth del panel platform — totalmente separado de AuthContext (cliente/tienda).
// El token vive en localStorage['platformToken'] para no chocar con el token de tienda.
export function PlatformAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("platformToken"));
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(!!token);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const checkAuth = async () => {
      if (!token) {
        if (!cancelled) {
          setIsAuthenticated(false);
          setAdmin(null);
          setLoading(false);
        }
        return;
      }
      try {
        const parts = token.split(".");
        if (parts.length !== 3) {
          if (!cancelled) logout();
          return;
        }
        const payload = JSON.parse(atob(parts[1]));
        if (Date.now() >= payload.exp * 1000) {
          if (!cancelled) logout();
          return;
        }

        const res = await api.platform.me();
        if (cancelled) return;
        if (res.status === "success") {
          setAdmin(res.data);
          setIsAuthenticated(true);
        } else {
          logout();
        }
      } catch (error) {
        if (error?.message?.includes("fetch")) {
          if (!cancelled) setLoading(false);
          return;
        }
        if (!cancelled) logout();
      }
      if (!cancelled) setLoading(false);
    };

    checkAuth();
    return () => { cancelled = true; };
  }, [token]);

  function login(newToken) {
    localStorage.setItem("platformToken", newToken);
    setToken(newToken);
  }

  function logout() {
    localStorage.removeItem("platformToken");
    setToken(null);
    setAdmin(null);
    setIsAuthenticated(false);
  }

  return (
    <PlatformAuthContext.Provider value={{ token, admin, loading, isAuthenticated, login, logout }}>
      {children}
    </PlatformAuthContext.Provider>
  );
}
